
import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Separator } from "@/components/ui/separator";

interface ProfileSocialMediaProps {
  biography: string;
  instagram: string;
  discord: string;
  twitch: string;
  youtube: string;
  setBiography: (value: string) => void;
  setInstagram: (value: string) => void;
  setDiscord: (value: string) => void;
  setTwitch: (value: string) => void;
  setYoutube: (value: string) => void;
}

export const ProfileSocialMedia = ({
  biography,
  instagram,
  discord,
  twitch,
  youtube,
  setBiography,
  setInstagram,
  setDiscord,
  setTwitch,
  setYoutube
}: ProfileSocialMediaProps) => {
  return (
    <Card className="bg-[#1A2233] border-[#222A35] text-white">
      <CardHeader>
        <CardTitle>Biografia e Redes Sociais</CardTitle>
        <CardDescription className="text-gray-400">
          Compartilhe mais sobre você e suas redes sociais
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="space-y-2">
          <Label htmlFor="bio">Biografia</Label>
          <Textarea 
            id="bio" 
            value={biography} 
            onChange={(e) => setBiography(e.target.value)}
            className="bg-[#242C37] border-[#2A3749] text-white min-h-24"
            placeholder="Conte um pouco sobre você e sua experiência nos jogos..."
          />
        </div>
        
        <Separator className="bg-[#222A35]" />
        
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="instagram">Instagram</Label>
            <Input 
              id="instagram" 
              value={instagram} 
              onChange={(e) => setInstagram(e.target.value)}
              className="bg-[#242C37] border-[#2A3749] text-white"
              placeholder="https://instagram.com/seuusuario"
            />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="discord">Discord</Label>
            <Input 
              id="discord" 
              value={discord} 
              onChange={(e) => setDiscord(e.target.value)}
              className="bg-[#242C37] border-[#2A3749] text-white"
              placeholder="Seu usuário#0000"
            />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="twitch">Twitch</Label>
            <Input 
              id="twitch" 
              value={twitch} 
              onChange={(e) => setTwitch(e.target.value)}
              className="bg-[#242C37] border-[#2A3749] text-white"
              placeholder="https://twitch.tv/seuusuario"
            />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="youtube">YouTube</Label>
            <Input 
              id="youtube" 
              value={youtube} 
              onChange={(e) => setYoutube(e.target.value)}
              className="bg-[#242C37] border-[#2A3749] text-white"
              placeholder="https://youtube.com/c/seucanal"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
